import { apiClient } from './apiClient';

export type ApiKeyScope =
  | 'counterparties:read'
  | 'bank_accounts:read'
  | 'invoices:read'
  | 'invoices:write';

export interface CompanyApiKey {
  id: string;
  name: string;
  keyPrefix: string;
  scopes: string[];
  lastUsedAt?: string | null;
  revokedAt?: string | null;
  createdAt?: string;
  apiKey?: string | null;
}

export const ALL_API_KEY_SCOPES: ApiKeyScope[] = [
  'counterparties:read',
  'bank_accounts:read',
  'invoices:read',
  'invoices:write',
];

export const companyApiKeyService = {
  list: async (companyId: string): Promise<CompanyApiKey[]> => {
    const { data } = await apiClient.get(`/companies/${companyId}/api-keys`);
    return data;
  },
  create: async (
    companyId: string,
    payload: { name: string; scopes: string[] }
  ): Promise<CompanyApiKey> => {
    const { data } = await apiClient.post(`/companies/${companyId}/api-keys`, payload);
    return data;
  },
  revoke: async (companyId: string, keyId: string): Promise<void> => {
    await apiClient.delete(`/companies/${companyId}/api-keys/${keyId}`);
  },
};
